/**
 * We use babel/polyfill to provide modern js support for old browsers e.g. Array.prototype.includes method which is used
 * https://babeljs.io/docs/en/babel-polyfill
 */
import "@babel/polyfill";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {AppStore} from './redux/AppStore';
import App from "./App/App";
import {StylesProvider} from "@material-ui/core";
import {unregister} from "./registerServiceWorker";
import "./styles/index.scss";

declare global {
    interface Window {
        __forceSmoothScrollPolyfill__: boolean;
    }
}
window.__forceSmoothScrollPolyfill__ = true;
import smoothscroll from 'smoothscroll-polyfill';


declare var process: any
declare var require: any

ReactDOM.render(
  <div>
    <StylesProvider injectFirst>
      <Provider store={AppStore}>
            <App/>
      </Provider>
    </StylesProvider>
  </div>,
  document.getElementById('nzpost-react-pkl') as HTMLElement
);

// TODO: We temporarily disable service worker to prevent the empty resources found for the legacy /apf site.
// Once we merge /apf to this then we need to
// registerServiceWorker();
unregister();

// requestAnimationFrame polyfill required for the smooth scrolling polyfill
require('raf/polyfill');

// kick off the polyfill!
smoothscroll.polyfill();



// WEBPACK FOOTER //
// ./src/index.tsx